import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { goToTop } from '_helpers';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';
import LMDetails from './components/LMDetails';
import LMCarousel from './components/LMCarousel';
import { Arrow } from '../../../styles/common-styles';

const LearningModules = ({
  learning_module,
  windowsWidth,
  setDisplayedContent,
  setRef,
  moduleIndex,
  setDisplayedLMDetails
}) => {
  const [lmPageIndex, setLmPageIndex] = useState(0);
  const [lmLessonItemIndex, setLmLessonItemIndex] = useState();
  const [showLmLessonDetails, setShowLmLessonDetails] = useState();
  const [itemPerPage, setItemPerPage] = useState(windowsWidth >= 700 ? 3 : 2);

  const learnMoreClickHandler = (index) => {
    setShowLmLessonDetails(`${index}`);
    setDisplayedContent('learningModules');
    setDisplayedLMDetails(`${moduleIndex}`);
    setLmLessonItemIndex(index);
    eventTracker(
      events.DZ_HOME_LM_ITEM_TAP,
      { activity_id: learning_module.videos[index].coachable_id }
    );
    goToTop();
  };

  const goBackHandler = () => {
    setDisplayedLMDetails();
    setShowLmLessonDetails();
    setDisplayedContent();
    eventTracker(events.DZ_LM_BACK_BTN_TAP, '');
    goToTop();
    setRef('learningModulesRef');
  };

  const nextLMHandler = () => {
    setLmLessonItemIndex((prevState) => prevState + 1);
    eventTracker(events.DZ_RF_NEXT_CTA_TAP, '');
    goToTop();
  };

  const previousLMHandler = () => {
    setLmLessonItemIndex((prevState) => prevState - 1);
    goToTop();
  };

  useEffect(() => {
    setItemPerPage(windowsWidth >= 700 ? 2 : 2);
  }, [windowsWidth]);

  useEffect(() => {
    setLmPageIndex(0);
  }, [itemPerPage]);

  return (
    <Container key={lmPageIndex}>
      <Title>
        {showLmLessonDetails && (
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
        )}

        {!showLmLessonDetails && learning_module.title}
      </Title>

      {showLmLessonDetails ? (
        <LMDetails
          key={lmLessonItemIndex}
          lmLessonItemIndex={lmLessonItemIndex}
          learning_module={learning_module}
          previousLMHandler={previousLMHandler}
          nextLMHandler={nextLMHandler}
        />
      ) : (
        <LMCarousel
          lmPageIndex={lmPageIndex}
          learning_module={learning_module}
          itemPerPage={itemPerPage}
          learnMoreClickHandler={learnMoreClickHandler}
          setLmPageIndex={setLmPageIndex}
        />
      )}
    </Container>
  );
};

export default connect(
  (store) => ({
    rf_lessons: store.education.rf_lessons,
    selectedLang: store.config.selectedLang
  })
)(LearningModules);

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const Container = styled.div`
  box-sizing: border-box;
  padding: 10px 0;
  padding-top: 5px;
  margin-top: 15px;
  overflow: hidden;
  position: relative;
  animation: ${OpacityAnimation} 0.5s;
`;

const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;
